export enum TextButtonTheme {
  Primary = "Primary",
}
